import Vue from 'vue'
import playground from './modules/playground'
import frame from './modules/frame'
import d2Crud from './modules/d2-crud'
import plugins from './modules/plugins'
import charts from './modules/charts'
import components from './modules/components'
import element from './modules/element'
import business from './modules/business'
import layoutHeaderAside from '@/layout/header-aside'
import VueRouter from 'vue-router'
const meta = {
  auth: true
}
Vue.use(VueRouter)
// const originalPush = VueRouter.prototype.push

// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
/**
 * 在主框架内显示
 */
const frameIn = [{
  path: '/',
  redirect: {
    name: 'index'
  },
  component: layoutHeaderAside,
  children: [
    // 首页 必须 name:index
    {
      path: 'index',
      name: 'index',
      meta,
      component: () =>
                        import('@/pages/index')
    },
    // 刷新页面 必须保留
    {
      path: 'refresh',
      name: 'refresh',
      hidden: true,
      component: {
        beforeRouteEnter (to, from, next) {
          next(vm => vm.$router.replace(from.fullPath))
        },
        render: h => h()
      }
    },
    // 页面重定向 必须保留
    {
      path: 'redirect/:route*',
      name: 'redirect',
      hidden: true,
      component: {
        beforeRouteEnter (to, from, next) {
          next(vm => vm.$router.replace(JSON.parse(from.params.route)))
        },
        render: h => h()
      }
    }

  ]
},

{
  path: '/pages/home',
  name: '首页',
  meta,
  redirect: {
    name: 'demo-frame-home'
  },
  component: layoutHeaderAside,
  children: (pre => [{
    path: 'index',
    name: `${pre}/index`,
    component: () => import('@/pages/home/'),
    meta: {
      ...meta,
      title: '首页'
    }
  }])('demo-frame-home')
},
{
  path: '/pages/sysManage',
  name: '系统管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'organization',
    name: `${pre}/organization`,
    component: () =>
                        import('@/pages/sysManage/organization/'),
    meta: {
      ...meta,
      title: '机构管理'
    }
  }, {
    path: 'usermanagement',
    name: `${pre}/usermanagement`,
    component: () =>
                        import('@/pages/sysManage/usermanagement.vue'),
    meta: {
      ...meta,
      title: '后台管理员'
    }
  }, {
    path: 'operator',
    name: `${pre}/operator`,
    component: () =>
                        import('@/pages/sysManage/operator'),
    meta: {
      ...meta,
      title: '机构管理员'
    }
  },
  {
    path: 'role',
    name: `${pre}、role`,
    component: () =>
                        import('@/pages/sysManage/role/'),
    meta: {
      ...meta,
      title: '角色管理'
    }
  }, {
    path: 'childOrganization',
    name: `${pre}/childOrganization`,
    component: () =>
                        import('@/pages/sysManage/childOrganization'),
    meta: {
      ...meta,
      title: '子机构管理'
    }
  }, {
    path: 'quotaRecord',
    name: `${pre}/quotaRecord`,
    component: () =>
                        import('@/pages/sysManage/quotaRecord'),
    meta: {
      ...meta,
      title: '额度记录'
    }
  }
  ])('demo-frame-sysManage')
},
{
  path: '/pages/advertmentManage',
  name: '广告管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'advertmentManage',
    name: `${pre}/advertmentManage`,
    component: () =>
                    import('@/pages/advertmentManage/advertmentManage.vue'),
    meta: {
      ...meta,
      title: '广告管理'
    }
  }])('demo-frame-advertmentManage')
},
{
  path: '/pages/advertisersManage',
  name: '广告主管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'launchRecord',
    name: `${pre}/launchRecord`,
    component: () =>
                        import('@/pages/advertisersManage/launchRecord.vue'),
    meta: {
      ...meta,
      title: '投放查询'
    }
  },
  {
    path: 'launchStatistical',
    name: `${pre}/launchStatistical`,
    component: () =>
                        import('@/pages/advertisersManage/launchStatistical.vue'),
    meta: {
      ...meta,
      title: '投放统计'
    }
  },
  {
    path: 'statisticsQuery',
    name: `${pre}/statisticsQuery`,
    component: () =>
                        import('@/pages/advertisersManage/statisticsQuery.vue'),
    meta: {
      ...meta,
      title: '统计数据查询'
    }
  },
  {
    path: 'launchModifyRecord',
    name: `${pre}/launchModifyRecord`,
    component: () =>
                        import('@/pages/advertisersManage/launchModifyRecord.vue'),
    meta: {
      ...meta,
      title: '投放信息申请'
    }
  },
  {
    path: 'launchModifyRecordApprova',
    name: `${pre}/launchModifyRecordApprovate`,
    component: () =>
                        import('@/pages/advertisersManage/launchModifyRecordApprova.vue'),
    meta: {
      ...meta,
      title: '投放审核日志'
    }
  }

  ])('demo-frame-advertisersManage')
}, {
  path: '/pages/flowMainManage',
  name: '广告投放管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [

    {
      path: 'defaultAdvertManage',
      name: `${pre}/defaultAdvertManage`,
      component: () =>
                        import('@/pages/flowMainManage/defaultAdvertManage.vue'),
      meta: {
        ...meta,
        title: '默认广告管理'
      }
    },
    {
      path: 'trafficmainadvertisement',
      name: `${pre}/trafficmainadvertisement`,
      component: () =>
                        import('@/pages/flowMainManage/trafficmainadvertisement.vue'),
      meta: {
        ...meta,
        title: '广告投放情况'
      }
    },
    {
      path: 'flowmainstatistics',
      name: `${pre}/flowmainstatistics`,
      component: () =>
                        import('@/pages/flowMainManage/flowmainstatistics.vue'),
      meta: {
        ...meta,
        title: '广告主统计'
      }
    }

  ])('demo-frame-flowMainManage')
},
{
  path: '/pages/couponManage',
  name: '优惠券管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'couponCategory',
    name: `${pre}/couponCategory`,
    component: () =>
                        import('@/pages/couponManage/couponCategory.vue'),
    meta: {
      ...meta,
      title: '优惠券类别管理'
    }
  },
  {
    path: 'couponGrantManage',
    name: `${pre}/couponGrantManage`,
    component: () =>
                        import('@/pages/couponManage/couponGrantManage.vue'),
    meta: {
      ...meta,
      title: '授权审核管理'
    }
  },
  {
    path: 'couponRecord',
    name: `${pre}/couponRecord`,
    component: () =>
                        import('@/pages/couponManage/couponRecord.vue'),
    meta: {
      ...meta,
      title: '券生成记录'
    }
  },
  {
    path: 'createCoupon',
    name: `${pre}/createCoupon`,
    component: () =>
                        import('@/pages/couponManage/createCoupon.vue'),
    meta: {
      ...meta,
      title: '生成优惠券'
    }
  },
  {
    path: 'distributeCoupon',
    name: `${pre}/distributeCoupon`,
    component: () =>
                        import('@/pages/couponManage/distributeCoupon.vue'),
    meta: {
      ...meta,
      title: '优惠券派发'
    }
  },
  {
    path: 'writeOffCoupon',
    name: `${pre}/writeOffCoupon`,
    component: () =>
                        import('@/pages/couponManage/writeOffCoupon.vue'),
    meta: {
      ...meta,
      title: '优惠券核销'
    }
  },
  {
    path: 'makePaper',
    name: `${pre}/makePaper`,
    component: () =>
                        import('@/pages/couponManage/makePaperCoupon.vue'),
    meta: {
      ...meta,
      title: '制作纸质券'
    }
  },
  {
    path: 'getRecord',
    name: `${pre}/getRecord`,
    component: () =>
                        import('@/pages/couponManage/getRecord.vue'),
    meta: {
      ...meta,
      title: '优惠券领取/派发记录'
    }
  }, {
    path: 'writeOffRecord',
    name: `${pre}/writeOffRecord`,
    component: () =>
                        import('@/pages/couponManage/writeOffRecord.vue'),
    meta: {
      ...meta,
      title: '使用（核销）情况'
    }
  }, {
    path: 'enterCoupon',
    name: `${pre}/enterCoupon`,
    component: () =>
                        import('@/pages/couponManage/enterCoupon.vue'),
    meta: {
      ...meta,
      title: '录入券'
    }
  },
  {
    path: 'couponStatistics',
    name: `${pre}/couponStatistics`,
    component: () =>
                        import('@/pages/couponManage/couponStatistics.vue'),
    meta: {
      ...meta,
      title: '优惠券统计'
    }
  },
  {
    path: 'couponCode',
    name: `${pre}/couponCode`,
    component: () =>
                        import('@/pages/couponManage/couponCode.vue'),
    meta: {
      ...meta,
      title: '套餐管理'
    }
  },
  {
    path: 'addCouponCode',
    name: `${pre}/addCouponCode`,
    component: () =>
                        import('@/pages/couponManage/addCouponCode.vue'),
    meta: {
      ...meta,
      title: '新增套餐'
    }
  },
  {
    path: 'putOnCouponCode',
    name: `${pre}/putOnCouponCode`,
    component: () =>
                        import('@/pages/couponManage/putOnCouponCode.vue'),
    meta: {
      ...meta,
      title: '同步至领券页'
    }
  },
  {
    path: 'empowerOrgStatistics',
    name: `${pre}/empowerOrgStatistics`,
    component: () =>
                        import('@/pages/couponManage/empowerOrgStatistics.vue'),
    meta: {
      ...meta,
      title: '授权派发核销统计'
    }
  },
  {
    path: 'couponCodeSynchRecord',
    name: `${pre}/couponCodeSynchRecord`,
    component: () =>
        import('@/pages/couponManage/couponCodeSynchRecord.vue'),
    meta: {
      ...meta,
      title: '同步申请记录'
    }
  },
  {
    path: 'couponType',
    name: `${pre}/couponType`,
    component: () =>
        import('@/pages/couponManage/couponType.vue'),
    meta: {
      ...meta,
      title: '券类别管理'
    }
  }

  ])('demo-frame-coupon')
},
{
  path: '/pages/writeOffManage',
  name: '核销管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'writeOffCouponAndCard',
    name: `${pre}/writeOffCouponAndCard`,
    component: () =>
                        import('@/pages/writeOffManage/writeOffCouponAndCard.vue'),
    meta: {
      ...meta,
      title: '核销'
    }
  },
  {
    path: 'cardCouponWriteOffStatistics',
    name: `${pre}/cardCouponWriteOffStatistics`,
    component: () =>
                        import('@/pages/writeOffManage/cardCouponWriteOffStatistics.vue'),
    meta: {
      ...meta,
      title: '券卡核销统计'
    }
  }, {
    path: 'writeOffRecordManage',
    name: `${pre}/writeOffRecordManage`,
    component: () =>
                        import('@/pages/writeOffManage/writeOffRecordManage.vue'),
    meta: {
      ...meta,
      title: '核销记录'
    }
  }
  ])('demo-frame-statisticsQuery')
},
{
  path: '/pages/cardManage',
  name: '储值卡管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'createCard',
    name: `${pre}/createCard`,
    component: () =>
                        import('@/pages/cardManage/createCard.vue'),
    meta: {
      ...meta,
      title: '制作储值卡'
    }
  },
  {
    path: 'cardInfo',
    name: `${pre}/cardInfo`,
    component: () =>
                        import('@/pages/cardManage/cardInfo.vue'),
    meta: {
      ...meta,
      title: '储值卡派发'
    }
  },
  {
    path: 'cardGetRecord',
    name: `${pre}/cardGetRecord`,
    component: () =>
                        import('@/pages/cardManage/cardGetRecord.vue'),
    meta: {
      ...meta,
      title: '储值卡派发/领取记录'
    }
  },

  {
    path: 'cardStatistics',
    name: `${pre}/cardStatistics`,
    component: () =>
                        import('@/pages/cardManage/cardStatistics.vue'),
    meta: {
      ...meta,
      title: '储值卡统计'
    }
  },
  {
    path: 'cardWriteOffRecord',
    name: `${pre}/cardWriteOffRecord`,
    component: () =>
                        import('@/pages/cardManage/cardWriteOffRecord.vue'),
    meta: {
      ...meta,
      title: '储值卡核销情况'
    }
  }
  ])('demo-frame-cardManage')
},
{
  path: '/pages/statisticsQuery',
  name: '券统计查询',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'getRecord',
    name: `${pre}/getRecord`,
    component: () =>
                        import('@/pages/statisticsQuery/getRecord.vue'),
    meta: {
      ...meta,
      title: '领取/派发记录'
    }
  },
  {
    path: 'writeOffRecord',
    name: `${pre}/writeOffRecord`,
    component: () =>
                        import('@/pages/statisticsQuery/writeOffRecord.vue'),
    meta: {
      ...meta,
      title: '使用（核销）情况'
    }
  }, {
    path: 'couponRecord',
    name: `${pre}/couponRecord`,
    component: () =>
                        import('@/pages/statisticsQuery/couponRecord.vue'),
    meta: {
      ...meta,
      title: '券生成记录'
    }
  }, {
    path: 'couponDetailRecord',
    name: `${pre}/record`,
    component: () =>
                        import('@/pages/statisticsQuery/couponDetailRecord.vue'),
    meta: {
      ...meta,
      title: '券生成明细'
    }
  }
  ])('demo-frame-statisticsQuery')
},
{
  path: '/pages/goods',
  name: '商品管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'goodsManage',
    name: `${pre}/goodsManage`,
    component: () =>
                        import('@/pages/goods/goodsManage.vue'),
    meta: {
      ...meta,
      title: '商品管理'
    }
  },
  {
    path: 'goodsAudit',
    name: `${pre}/goodsAudit`,
    component: () =>
                        import('@/pages/goods/goodsAudit.vue'),
    meta: {
      ...meta,
      title: '上架审核'
    }
  },
  {
    path: 'goodsRecords',
    name: `${pre}/goodsRecords`,
    component: () =>
                        import('@/pages/goods/goodsRecords.vue'),
    meta: {
      ...meta,
      title: '操作记录'
    }
  },
  {
    path: 'memberDayManage',
    name: `${pre}/memberDayManage`,
    component: () =>
          import('@/pages/goods/memberDayManage.vue'),
    meta: {
      ...meta,
      title: '会员日管理'
    }
  }
  ])('demo-frame-goods')
},
{
  path: '/pages/order',
  name: '订单管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'orderManage',
    name: `${pre}/orderManage`,
    component: () =>
                        import('@/pages/order/orderManage.vue'),
    meta: {
      ...meta,
      title: '订单管理'
    }
  },
  {
    path: 'refundManage',
    name: `${pre}/refundManage`,
    component: () =>
                        import('@/pages/order/refundManage.vue'),
    meta: {
      ...meta,
      title: '退款审核'
    }
  },
  {
    path: 'orderStatistics',
    name: `${pre}/orderStatistics`,
    component: () =>
                        import('@/pages/order/orderStatistics.vue'),
    meta: {
      ...meta,
      title: '销售统计'
    }
  },
  {
    path: 'businessStatistics',
    name: `${pre}/businessStatistics`,
    component: () =>
                        import('@/pages/order/businessStatistics.vue'),
    meta: {
      ...meta,
      title: '销售统计'
    }
  }

  ])('demo-frame-order')
},
{
  path: '/pages/cust',
  name: '用户管理',
  meta,
  redirect: {
    name: 'demo-frame-index'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'custManage',
    name: `${pre}/custManage`,
    component: () =>
                        import('@/pages/cust/custManage.vue'),
    meta: {
      ...meta,
      title: '用户管理'
    }
  }
  ])('demo-frame-cust')
},
{
  path: '/pages/scoreManage',
  name: '积分管理',
  meta,
  redirect: {
    name: 'demo-frame-scoreManage'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'signRuleManage',
    name: `${pre}/signRuleManage`,
    component: () =>
                        import('@/pages/scoreManage/signRuleManage.vue'),
    meta: {
      ...meta,
      title: '签到设置'
    }
  },
  {
    path: 'scoreRecord',
    name: `${pre}/scoreRecord`,
    component: () =>
                        import('@/pages/scoreManage/scoreRecord.vue'),
    meta: {
      ...meta,
      title: '积分记录'
    }
  },
  {
    path: 'userScore',
    name: `${pre}/userScore`,
    component: () =>
                        import('@/pages/scoreManage/userScore.vue'),
    meta: {
      ...meta,
      title: '用户积分'
    }
  }

  ])('demo-frame-scoreManage')
},
{
  path: '/pages/memberLevelManage',
  name: '时间套餐管理',
  meta,
  redirect: {
    name: 'demo-frame-memberLevelManage'
  },
  component: layoutHeaderAside,
  children: ((pre) => [{
    path: 'setting',
    name: `${pre}/setting`,
    component: () => import('@/pages/memberLevelManage/setting.vue'),
    meta: {
      ...meta,
      title: '时间套餐设置'
    }
  },
  {
    path: 'records',
    name: `${pre}/records`,
    component: () => import('@/pages/memberLevelManage/records.vue'),
    meta: {
      ...meta,
      title: '套餐使用记录'
    }
  }
  ])('demo-frame-memberLevelManage')
},


{
  path: '/pages/shopManage',
  name: '首页',
  meta,
  redirect: {
    name: 'demo-frame-shopAdvertManage'
  },
  component: layoutHeaderAside,
  children: (pre => [{
    path: 'shopAdvertManage',
    name: `${pre}/shopAdvertManage`,
    component: () => import('@/pages/shopManage/shopAdvertManage/'),
    meta: {
      ...meta,
      title: '商城广告管理'
    }
  }, {
    path: 'shopHomeLinkManage',
    name: `${pre}/shopHomeLinkManage`,
    component: () => import('@/pages/shopManage/shopHomeLinkManage/'),
    meta: {
      ...meta,
      title: '商城首页荟打折管理'
    }
  }])('demo-frame-shopAdvertManage')

},

playground,
frame,
d2Crud,
plugins,
charts,
components,
element,
business
]
/**
     * 在主框架之外显示
     */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () =>
            import('@/pages/login')
  }
]

/**
 * 错误页面
 */
const errorPage = [
  // 404
  {
    path: '*',
    name: '404',
    component: () =>
            import('@/pages/error-page-404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage]
